module.exports = "<p>\r\n  packinglist works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/packinglist/packinglist.component.html
// module id = ../../../../../src/app/components/packinglist/packinglist.component.html
// module chunks = main